export default __webpack_public_path__ + "static/media/kid1.d45980a1.jpg";